import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { GearUrl } from "@prisma/client";
import { Button, Input, Space } from "antd";
import { FunctionComponent, useCallback, useEffect, useMemo } from "react";
import cleanUrl from "./clean-url";
import createUrl from "./create-url";
import { UrlDataWithMeta } from "./UrlDataWithMeta";


interface GearUrlProps {
  value?: UrlDataWithMeta[];
  onChange?: (value: UrlDataWithMeta[]) => void;
}

let id = 5;

const getInitialUrl = async () => {
  // if inside chrome extension, get the current tab url
  // else return null

  // check if inside extension
  if (chrome && chrome.tabs) {
    const tab = await chrome.tabs.query({
      active: true,
      currentWindow: true,
    });
    return cleanUrl(tab[0].url);
  }

  return null;
};

const GearUrl: FunctionComponent<GearUrlProps> = ({ value = [], onChange }) => {
  const filteredValue = useMemo(
    () =>
      Array.isArray(value)
        ? value.filter((e) => {
          if (e?.__action === "delete") {
            return false;
          }
          return true;
        })
        : [],
    [value]
  );

  const onChangeValue = useCallback(
    (id: string, prop: keyof GearUrl, value: string) => {
      const newValue = filteredValue.map((e) => {
        if (e.id === id) {
          return {
            ...e,
            [prop]: value,
            __action: e?.__action === "create" ? "create" : "update",
          } as UrlDataWithMeta;
        }
        return e;
      });
      onChange && onChange(newValue);
    },
    [value, onChange]
  );

  const onDelete = useCallback(
    (id: string) => {
      const newValue = filteredValue.map((e) => {
        if (e.id === id) {
          return { ...e, __action: "delete" } as UrlDataWithMeta;
        }
        return e;
      });
      onChange && onChange(newValue);
    },
    [value, onChange]
  );
  const onAdd = useCallback(async () => {
    const initialUrl = await getInitialUrl();
    const data = createUrl(initialUrl!);
    const newValue = [...value, data];
    onChange && onChange(newValue);
  }, [value, onChange]);

  useEffect(() => {
    if (filteredValue.length === 0) {
      setTimeout(onAdd, 10);
    }
  }, [filteredValue, onAdd]);

  return (
    <Space
      direction="vertical"
      style={{
        width: "100%",
      }}
    >
      {filteredValue.map((e, i, arr) => {
        return (
          <Space
            direction="vertical"
            key={e.id}
            style={{
              width: `calc(100% - 32px)`,
              position: "relative",
            }}
          >
            <Input
              value={e.root_url || ""}
              onChange={(ev) =>
                onChangeValue(e.id, "root_url", cleanUrl(ev.target.value) || "")
              }
              addonBefore="Url"
            />
            <Input
              value={e.contains || ""}
              onChange={(ev) =>
                onChangeValue(e.id, "contains", ev.target.value)
              }
              addonBefore="Contains"
            />
            <Button
              style={{
                position: "absolute",
                top: 4,
                right: -32,
              }}
              size="small"
              onClick={() => onDelete(e.id)}
              icon={<DeleteOutlined />}
            />
          </Space>
        );
      })}
      <Space
        direction="vertical"
        align="end"
        style={{
          width: `100%`,
        }}
      >
        <Button
          type="primary"
          size="small"
          onClick={onAdd}
          icon={<PlusOutlined />}
        >
          Add Url
        </Button>
      </Space>
    </Space>
  );
};

export default GearUrl;
